/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TriState = {
    False: 'False',
    True: 'True',
    Warning: 'Warning'
} as const;
export type TriState = typeof TriState[keyof typeof TriState];


export function TriStateFromJSON(json: any): TriState {
    return TriStateFromJSONTyped(json, false);
}

export function TriStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriState {
    return json as TriState;
}

export function TriStateToJSON(value?: TriState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the TriState interface.
 */
 export function instanceOfTriState(value: any): value is TriState {
    return Object.values(TriState).includes(value)
}

